const WhiteBox = ({children}) => (
  <div className="bg-white p-14">{children}</div>
);

export default WhiteBox; 
  